<template>
  <div class="chart" :style="{ height: height }" />
</template>

<script>
//import { echarts } from "echarts";
import * as echarts from "echarts";
require("echarts/theme/shine"); // echarts theme
export default {
  props: [
    "meter",
    "current",
    "vectors",
    "contract",
    "projectedConsumption",
    "start",
  ],
  data() {
    return {
      chart: null,
      sidebarElm: null,
      height: "450px",
      autoResize: true,
      meters: this.$props.meter,
      months: {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "Jul",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
      },
    };
  },
  mounted() {
    this.initChart();
    if (this.autoResize) {
      this.__resizeHandler = this.debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener("resize", this.__resizeHandler);
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.__resizeHandler);
    }
    this.sidebarElm &&
      this.sidebarElm.removeEventListener(
        "transitionend",
        this.sidebarResizeHandler
      );
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    sidebarResizeHandler(e) {
      if (e.propertyName === "width") {
        this.__resizeHandler();
      }
    },
    setOptions() {
      this.chart.setOption({
        animationDuration: 5000,
        smooth: true,
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        title: {
          left: "left",
          text: "Energy Sold",
          padding: [0, 0, 60, 20],
          textStyle: {
            fontWeight: 700,
            color: "#000"
          },
          subtext: "Down 9% from last week",
          subtextStyle: {
            color: "#ea526f"
          }
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            lineStyle: { color: "#79cd89" },
            itemStyle: { color: "#79cd89" },
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(121,205,137,0.8)",
                },
                {
                  offset: 1,
                  color: "rgba(242,250,250,0.3)",
                },
              ]),
            },
          },
        ],
      });
    },
    initChart() {
      this.chart = echarts.init(this.$el, "shine");
      this.setOptions();
    },
    debounce(func, wait, immediate) {
      let timeout, args, context, timestamp, result;
      const later = function () {
        // According to the last trigger interval
        const last = new Date().getTime() - timestamp;
        // The last time the wrapped function was called, the interval is last less than the set time interval wait
        if (last < wait && last > 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
          if (!immediate) {
            result = func.apply(context, args);
            if (!timeout) {
              context = args = null;
            }
          }
        }
      };
      return function (...args) {
        context = this;
        timestamp = new Date().getTime();
        const callNow = immediate && !timeout;
        // If the delay does not exist, reset the delay
        if (!timeout) {
          timeout = setTimeout(later, wait);
        }
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }
        return result;
      };
    },
  },
};
</script>